var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { isValid } from 'date-fns';
import { useCallback, useMemo, useRef, useState } from 'react';
import { MONTHS_PER_YEAR } from '../../DatePicker.constants';
import { getDayNames, getDisplayDates } from '../../DatePicker.services';
import { DatePickerContext } from '../DatePickerContext';
import styles from './DatePickerProvider.module.css';
export const DatePickerProvider = ({ children, closeOnSelect = true, focusedDayRef, id, initialValue, max, min, onChange, setIsCalendarOpen, value = new Date(), wordings, }) => {
    _react_refresh_temp_2();
    const [focusedDate, setFocusedDate] = useState(value);
    // patch when focused date is an invalid date (e.g. the input was cleared)
    const finalDate = useMemo(() => {
        if (isValid(focusedDate)) {
            return focusedDate;
        }
        return isValid(initialValue) ? initialValue : new Date();
    }, [focusedDate, initialValue]);
    const dateWordings = useMemo(() => {
        return {
            monthNames: [...Array(MONTHS_PER_YEAR).keys()].map((key) => new Date(0, key).toLocaleString('en', { month: 'long' })),
            dayNames: getDayNames(),
        };
    }, []);
    const onSelectDate = useCallback((date) => {
        setFocusedDate(date);
        onChange(date);
        if (closeOnSelect) {
            setIsCalendarOpen(false);
        }
    }, [closeOnSelect, onChange, setIsCalendarOpen]);
    const onPrevMonth = useCallback(() => {
        const firstDayPrevMonth = new Date(finalDate.getFullYear(), finalDate.getMonth() - 1, 1);
        setFocusedDate(firstDayPrevMonth);
    }, [finalDate]);
    const onNextMonth = useCallback(() => {
        const firstDayNextMonth = new Date(finalDate.getFullYear(), finalDate.getMonth() + 1, 1);
        setFocusedDate(firstDayNextMonth);
    }, [finalDate]);
    const containerRef = useRef(null);
    const providerValue = useMemo(() => ({
        min,
        max,
        displayDates: getDisplayDates(finalDate),
        dateWordings,
        focusedDate: finalDate,
        onNextMonth,
        onPrevMonth,
        onSelectDate,
        setFocusedDate,
        id,
        value,
        setIsCalendarOpen,
        wordings,
        focusedDayRef,
    }), [
        min,
        max,
        finalDate,
        dateWordings,
        onNextMonth,
        onPrevMonth,
        onSelectDate,
        id,
        value,
        setIsCalendarOpen,
        wordings,
        focusedDayRef,
    ]);
    return (_jsx(DatePickerContext.Provider, { value: providerValue, children: _jsx("div", { className: styles.Container, ref: containerRef, children: children }) }));
};
_react_refresh_temp_1 = DatePickerProvider;
$RefreshReg$(_react_refresh_temp_1, "DatePickerProvider");
_react_refresh_temp_2(DatePickerProvider, "Jb66cbXR7qguSCc6MFHDYhGYdS4=");
